import {
  AssignmentIndOutlined,
  BusinessCenterOutlined,
  PhoneIphoneOutlined,
  WifiOutlined,
} from '@vst/beam-icons/icons';
import { TFunction } from 'i18next';

import { AccountType } from '@mfe/shared/schema-types';

import { ProfileTab } from '../../types';

const getProfileHeaderLabels = (accountType: string, t: TFunction, showAddons: boolean) => {
  const navIcon = {
    residential: {
      accountInfoIcon: AssignmentIndOutlined,
      contactInfoIcon: PhoneIphoneOutlined,
    },
    smb: {
      accountInfoIcon: AssignmentIndOutlined,
      contactInfoIcon: BusinessCenterOutlined,
    },
    common: {
      internetPlanIcon: WifiOutlined,
    },
  };

  const internetInfoLabel = showAddons
    ? t('nav', {
        context: ProfileTab.InternetPlan,
      })
    : t('myPlanCardTitle');

  const sendResidentialNavLabels = () => {
    return {
      accountInfoIcon: navIcon.residential.accountInfoIcon,
      contactInfoIcon: navIcon.residential.contactInfoIcon,
      internetPlanIcon: navIcon.common.internetPlanIcon,
      accountInfoLabel: t('nav', {
        context: ProfileTab.ResidentialAccount,
      }),
      contactInfoLabel: t('nav', {
        context: ProfileTab.ResidentialContact,
      }),
      internetInfoLabel,
    };
  };

  if (!accountType) {
    return { ...sendResidentialNavLabels() };
  }

  const isBusinessCustomer = accountType?.toUpperCase() === AccountType.Smb;

  if (isBusinessCustomer) {
    return {
      accountInfoIcon: navIcon.smb.accountInfoIcon,
      contactInfoIcon: navIcon.smb.contactInfoIcon,
      internetPlanIcon: navIcon.common.internetPlanIcon,
      accountInfoLabel: t('nav', {
        context: ProfileTab.SMBAccount,
      }),
      contactInfoLabel: t('nav', {
        context: ProfileTab.SMBBusiness,
      }),
      internetInfoLabel,
    };
  }

  return { ...sendResidentialNavLabels() };
};

export const getNavItems = (currentTab: string, accountType: string, t: TFunction, showAddons: boolean) => {
  const profileTabProps = getProfileHeaderLabels(accountType, t, showAddons);
  const isSMB = accountType === AccountType.Smb;

  const dropdownProps = [
    {
      icon: profileTabProps.accountInfoIcon,
      id: isSMB ? ProfileTab.SMBAccount : ProfileTab.ResidentialAccount,
      label: profileTabProps.accountInfoLabel,
    },
    {
      icon: profileTabProps.contactInfoIcon,
      id: isSMB ? ProfileTab.SMBBusiness : ProfileTab.ResidentialContact,
      label: profileTabProps.contactInfoLabel,
    },
    {
      icon: profileTabProps.internetPlanIcon,
      id: ProfileTab.InternetPlan,
      label: profileTabProps.internetInfoLabel,
    },
  ];

  const selectedItem = dropdownProps.filter((item) => item.id === currentTab);
  const extendedItems = dropdownProps.filter((item) => item.id !== currentTab);
  return { navBarItems: dropdownProps, selectedItem, extendedItems };
};
